import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FieldConfig } from '../../models/field.interface';
import { ValidationService, ValidationType } from '../../services/validation.service';
import { StyleService } from '../../services/style.service';
@Component({
  selector: 'app-input',
  template: `
<div [formGroup]="group" *ngIf="field.style.visibility && !field.dynamic">
  <div class="hazard-description">
    <p class="dynamic-paragraph">{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
    <input class="form-control focus-color" maxlength="50" [ngStyle]="_styleService.applyStyle(field)" value="{{field.value}}" [disabled]="isDisabled()" placeholder="Enter short text here..." (change)="onChange($event.target)" (mouseenter)="mouseEnter($event.target)" (mouseleave)="mouseLeave($event.target)">
    <span class="error-message" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span>
  </div>
</div>
<div [formGroup]="group" *ngIf="field.dynamic && field.style.visibility" class="dynamic-property">
  <div class="hazard-description">
    <p class="dynamic-paragraph">{{field.name}} <b *ngIf="field.validation.isRequired">*</b></p>
    <div *ngFor="let x of field.value; let i = index;trackBy:trackByIndex;" class="inputfields">
      <input class="form-control focus-color dynamic-input" maxlength="50" [(ngModel)]="field.value[i]" [disabled]="isDisabled()" [ngModelOptions]="{standalone :true}" placeholder="Enter short text here..." (change)="onChangeForDynamic($event.target, i)">
      <ng-container *ngIf="deleteShow">
      <div class="btn delete-item for-some-fields" [ngClass]="{'pointer-events' : !field.style.editability}" (click)="deletShortText(i)"><img src="assets/rff-images/delete-dynamic.svg"></div>
      </ng-container>
    </div>
    <span class="error-message dynamic-ermsg" *ngIf="field.errorMessage !== ''">{{field.errorMessage}}</span> 
  </div>
  <div class="btn-dynamic">
    <div class="btn btn-default" [ngClass]="{'pointer-events' : !field.style.editability}" (click)="dynamicShortText()"><img src="assets/rff-images/add-img.svg"> Add another field</div>
  </div>
</div>
    `,
  styles: []
})
export class shortTextComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  deleteShow = false;
  constructor(
    private _validationService: ValidationService,
    private  _styleService : StyleService
  ) { }
  onChange(event) {
    this.field.value = event.value;
    this.group.value[this.field.id] = this.field.value;    
    const data = this.group.value;
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }
  mouseEnter(event) {
    this.field.value = event.value;
  }
  mouseLeave(event) {
    this.field.value = event.value;
  }

  // dynamic short text
  onChangeForDynamic(event, index) {
    this.field.value = Object.assign([], this.field.value, {
      [index]: event.value
    });
    this.group.value[this.field.id] = this.field.value;
    const data = this.group.value[this.field.id];
    this._validationService.applyValidation(this.field, data, [ValidationType.isRequired, ValidationType.onChange]);
  }
  trackByIndex(index: number) {
    return index;
  }
  dynamicShortText() {
    this.field.value.push('');
    this.deleteShow = true;
  }
  deletShortText(i) {
    this.field.value.splice(i, 1);
    if (i === 1) {
      this.deleteShow = false; 
     }
  }

  ngOnInit() {
    if (!this.field.dynamic && this.field.value === undefined && this.field.value !== " ") {
      this.field.value = '';
    }
    if (this.field.dynamic && this.field.value === undefined) {
      this.field.value = [''];
    }
    if (this.field.dynamic && this.field.value.length > 1) {
      this.deleteShow = true; 
     }
  }
  isDisabled() : boolean{
    if(!this.field.style.editability)return true;
  }
 
}



// WEBPACK FOOTER //
// ./src/app/rFF/fields/short-text/short-text.component.ts